import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './Text.module.css'

const Text = ({ children, className, ...props }) => (
    <div className={cx(styles.wrapper, className)} {...props}>
        {children}
    </div>
)

Text.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
}

export default Text
